import axios from "axios"
import store from "../store/index"
import router from '../router/index'
const baseUrl = store.state.baseUrl
    //创建实例
const instance = axios.create({
    timeout: 15000,
    baseURL: baseUrl,
})

//请求前的拦截器
instance.interceptors.request.use(
    (config) => {
        if (sessionStorage.getItem("token")) {
            config.headers["Authorization"] = sessionStorage.getItem("token")
        }
        return config
    },
    (err) => {
        return Promise.reject(err)
    })

//响应结果的拦截器
instance.interceptors.response.use(
    (res) => {
        if (res.data.errno === 1000) {
            localStorage.clear() //全部清除
            window.location.reload() //强制刷新一次
        }
        return res.data
    },
    err => {
        router.push('/home')
        Promise.reject(err)
    })


// 导出
export default instance


// WEBPACK FOOTER //
// ./src/request/request.js